import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastService } from '../toast/toast.service';
import { FormControl, FormGroup } from '@angular/forms';
import { DataFormModel } from '../../models/data-form-model.model';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(
    public toastService: ToastService,
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR objectKeys                             */
  /* -------------------------------------------------------------------------- */
  // region objectKeys
  objectKeys(obj: any) {
    return Object.keys(obj);
  }

  /* -------------------------------------------------------------------------- */
  /*                             ANCHOR base64ToBlob                            */
  /* -------------------------------------------------------------------------- */
  // region base64ToBlob
  base64ToBlob(
    base64: string,
  ): Blob {

    const byteString = atob(base64);
    const len = byteString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) bytes[i] = byteString.charCodeAt(i);

    return new Blob([bytes], { type: 'image/jpeg' });
  }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR buildForm                              */
  /* -------------------------------------------------------------------------- */
  // region buildForm
  buildForm(obj: DataFormModel): FormGroup {

    const group: { [key: string]: FormControl } = {};

    Object.keys(obj).forEach(key => {
      group[key] = new FormControl(
        obj[key].value, obj[key].validators
      );
    });

    return new FormGroup(group);
    
  }

  /* -------------------------------------------------------------------------- */
  /*                           ANCHOR copyToClipboard                           */
  /* -------------------------------------------------------------------------- */
  // region copyToClipboard
  copyToClipboard(text: string) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);

    this.toastService.show({
      body: 'Copiado en el portapapeles',
      classname: 'bg-dark text-white',
    });
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR headers                               */
  /* -------------------------------------------------------------------------- */
  // region headers
  headers(
    token: string
  ): HttpHeaders {
    return new HttpHeaders({
      'Authorization': token,
      'Content-Type': 'application/json'
    });
  }

}
